import React, { useEffect, useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { Modal, Progress } from 'semantic-ui-react';

import user from '../../store/user';
import Heading from '../../components/Heading';
import Loader from '../../components/Loader';
import Button from '../../components/Button';

import { adminFeatureMapping } from '../../models/adminFeatureMapping';
import getFreeListingFilesList from '../../services/getFreeListingFilesList';
import getFreeListingSignedUrl from '../../services/getFreeListingSignedUrl';

import './styles.scss';

const FreeListingReportDownload = () => {
    const [adminId, setAdminId] = useState(null);
    const [filesList, setFilesList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [downloadingFile, setDownloadingFile] = useState(null);
    const [downloadProgress, setDownloadProgress] = useState(0);

    const getFilesList = async () => {
        try {
            const response = await getFreeListingFilesList(adminId);

            if (response && response.data && response.data.data && response.data.data.list) {
                setFilesList(response.data.data.list);
            } else {
                toast.error('No Files Found');
            }
            setIsLoading(false);
        } catch (error) {
            // console.log(error);
            toast.error('Failed to fetch files list. Please try again later');
            setIsLoading(false);
        }
    };

    useEffect(() => {
        async function getProfile () {
            const profile = await user.getProfile();
            return profile;
        }

        getProfile().then(data => {
            if (!user.checkFeatureAccess(adminFeatureMapping.FREE_LISTING_REPORTS)) {
                window.location.href = '/notAdmin';
            }

            setAdminId(data.id);
        });
    });

    useEffect(() => {
        if (adminId) {
            getFilesList();
        }
    }, [adminId]);

    const handleDownloadClick = async (filename) => {
        try {
            const response = await getFreeListingSignedUrl(adminId, { filename }, function(progressEvent) {
                try {
                    const loaded = parseFloat(progressEvent.loaded);
                    const total = parseFloat(progressEvent.total)

                    setDownloadProgress(Math.floor(loaded / total * 100));
                } catch (error) {
                    // console.log(error);
                }
            });

            const blob = new Blob([response.data], { type: 'application/xlsx; charset=utf-8' });
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.setAttribute('href', url);
            link.setAttribute('download', filename);
            link.style.visibility = 'hidden';
            
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            // console.log(error);
            toast.error('Failed to fetch file, Please try again later');
        }

        setDownloadingFile(null);
    }

    let selectedFileName = '';

    if (downloadingFile) {
        const file = filesList.filter(item => item.id == downloadingFile);

        if (file && file.length > 0) {
            selectedFileName = file[0]['file'];
        }
    }

    return (
        <div className='page-content free-listing-report-download'>
            <ToastContainer 
                position='bottom-left'
                hideProgressBar
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnHover={true}
                pauseOnFocusLoss={true}
                draggable={false}
            />

            <div className='page-heading'>
                <Heading text={'Download Free Listing Jobs Report'} />
            </div>

            <div className='page-content'>
                {isLoading ? (
                    <Loader />
                ) : null}

                {!isLoading && filesList.length > 0 ? (
                    <div className='fileslist__container'>
                        <div className='fileslist__container--latest'>
                            <div className='heading'>Donwload Latest Report:</div>
                            <div key={filesList[0].id} className='file-item'>
                                
                                <div className='file-item-meta'>
                                    <div><strong>Filename:</strong> {filesList[0].file}</div>
                                    <div><strong>Date Uploaded:</strong> {filesList[0].date}</div>
                                </div>
                                <div className='file-item-actions'>
                                    <Button 
                                        text={downloadingFile == filesList[0].id ? 'Downloading...' : 'Download'}
                                        loading={downloadingFile == filesList[0].id}
                                        disabled={downloadingFile}
                                        clickButton={() => {
                                            setDownloadProgress(0);
                                            setDownloadingFile(filesList[0].id);
                                            handleDownloadClick(filesList[0].file);
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className='fileslist__container--older'>
                            <div className='heading'>Download Older Files:</div>
                            {filesList.map((item, index) => {
                                if (index == 0) {
                                    return;
                                }
                                return (
                                    <div key={item.id} className='file-item'>
                                        <div className='file-item-meta'>
                                            <div><strong>Filename:</strong> {item.file}</div>
                                            <div><strong>Date Uploaded:</strong> {item.date}</div>
                                        </div>
                                        <div className='file-item-actions'>
                                            <Button 
                                                text={downloadingFile == item.id ? 'Downloading...' : 'Download'}
                                                loading={downloadingFile == item.id}
                                                disabled={downloadingFile}
                                                clickButton={() => {
                                                    setDownloadProgress(0);
                                                    setDownloadingFile(item.id);
                                                    handleDownloadClick(item.file);
                                                }}
                                            />
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                ) : null}

                {!isLoading && (!filesList || filesList.length === 0) ? (
                    <div className='error'>
                        No files found
                    </div>

                ) : null}

            </div>

            {downloadingFile ? (
                <Modal 
                    open={true}
                >
                    <Modal.Header>
                        Downloading {selectedFileName}
                    </Modal.Header>
                    <Modal.Content>

                        <div>
                            {downloadProgress > 50 ? 'Downloading' : 'Preparing'} file...

                            <Progress 
                                active={true}
                                value={downloadProgress}
                                total={100}
                            />
                        </div>
                    </Modal.Content>

                </Modal>
            ) : null}
        </div>
    );
};

export default FreeListingReportDownload;